import Vue from 'vue'
import App from './App.vue'
import { createStore } from './store.js'

import './index.scss'
Vue.config.productionTip = false

export default function createApp() {
  const store = createStore()
  const app = new Vue({
    render: (h) => h(App),
    store,
    mounted() {
      document.dispatchEvent(new Event('render-event'))
    },
  })
  return { app, store }
}
